import styles from './PageBody.module.scss'

import React from 'react'
import classnames, { Value } from 'classnames'
import Container from '../Container/Container'

interface Props {
    className?: Value
}

const PageBody: React.FC<Props> = ({ className, children }) => {
    return (
        <div className={classnames(styles.container, className)}>
            <Container className={styles.inner}>{children}</Container>
        </div>
    )
}

export default PageBody
